import BaseStep from './BaseStep.js';
import {Helper} from "../../helpers/Helper.js";

export default class DefaultFields extends BaseStep{
    _init() {
        this._MultiStepForms.Hook.addAction('addWatchers', () => {
            this.#watchFields();
        });
        this._MultiStepForms.Hook.addAction('init', () => {
            this.#initPaging();
        });

		this._MultiStepForms.Hook.addAction('nextStep', () => {
			const names = [];

			this._MultiStepForms.formWrapper.querySelectorAll('input,textarea,select')?.forEach(field => {
				if (!names.includes(field.name)) {
					this._MultiStepForms.formWrapper.querySelectorAll(`[name="${field.name}"]`).forEach( (f, index, all) => {
						if (f !== field){
							this.#setFieldValue(f, field);
						}
					});

					this._MultiStepForms.formWrapper.querySelectorAll(`[data-name="${field.name}"]`).forEach((value, index, all) => {
						this.setVisibleValue(value, field);
					});

					names.push(field.name);
				}
			})
		});
    }

    #watchFields() {
		this.#initTextareas();
		document.querySelector("input[name='campaign_goal_other_amount'], input[name='team_campaign_goal_other_amount']")?.addEventListener("keypress", function (evt) {
			if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57)
			{
				evt.preventDefault();
			}
		});
        this._MultiStepForms.handleEvent('input,change', 'input,textarea,select', (event, field) => {
            if (field.name) {
                this._MultiStepForms.formWrapper.querySelectorAll(`[name="${field.name}"]`).forEach( (f, index, all) => {
                    if (f !== field){
                        this.#setFieldValue(f, field);
                    }
                });

                this._MultiStepForms.formWrapper.querySelectorAll(`[data-name="${field.name}"]`).forEach((value, index, all) => {
                    this.setVisibleValue(value, field);
                });

            }
        });

        this._MultiStepForms.handleEvent('click', '.edit-button', (event, button) => {
            event.preventDefault();

            const fieldsContainer = button.closest('.form-group');

            if (button?.dataset?.edit && button?.dataset?.confirm) {
                fieldsContainer.classList.toggle('is-edit');
            }


			const parentGroup = event.target.closest('.form-group.campaign-goal');
			if (parentGroup) {
				const fieldsContainer = parentGroup.querySelector('.fields');
				const selectField = parentGroup.querySelector('select[name="campaign_goal"]');
				if (selectField?.name === 'campaign_goal') {
					const selectedOption = selectField.options[selectField.selectedIndex];
					const goalWithoutValue = selectedOption?.dataset?.novalue;

					if (goalWithoutValue === 'on') {
						const otherWrapper = fieldsContainer?.querySelector('.campaign-goal-other-wrapper');
						const campaignGoalOtherAmountWrapper = fieldsContainer?.querySelector('.campaign_goal_other_amount_wrapper');

						if (otherWrapper) {
							otherWrapper.style.display = '';
							if (campaignGoalOtherAmountWrapper?.classList.contains('hidden')) {
								campaignGoalOtherAmountWrapper.classList.remove('hidden');
							}
						}
					}
				}
			}



            if (fieldsContainer.classList.contains('is-edit')) {
                if (button?.dataset?.confirm) {
                    button.textContent = button.dataset.confirm;
                }
            } else {
                if (button?.dataset?.edit) {
                    button.textContent = button.dataset.edit;
                }
            }

            this._MultiStepForms.Hook.doAction('fieldEdit', fieldsContainer, button);
        })
    }

    setVisibleValue(value, field) {
		if (!field || field.name === 'action') return;

        if (field.type === 'file') {
            const files = field.files;

            if (files.length) {

                if (value.nodeName === 'IMG' || value.nodeName === 'VIDEO' || value.nodeName === 'AUDIO') {
                    value.src = URL.createObjectURL(files[0]);

                    value.alt = files[0].name;
                } else {
                    if (files.length > 3) {
                        value.textContent = files.length + ' ' + wp.i18n.__('Files', 'levcharity');
                    } else {
                        let filenames = [];

                        for (const file of files) {
                            filenames.push(file.name);
                        }

                        const val = filenames.join(', ');

                        value.textContent = val;
                    }
                }
            }
        } else if (field.type === 'checkbox') {
            if (!value.classList.contains('is-check')) {
                value.textContent = field.checked ? wp.i18n.__('Yes', 'levcharity') : wp.i18n.__('No', 'levcharity');
            } else {
                value.querySelector(`[data-status="${field.checked}"]`) && (value.querySelector(`[data-status="${field.checked}"]`).style.display = '');
                value.querySelector(`[data-status="${!field.checked}"]`) && (value.querySelector(`[data-status="${!field.checked}"]`).style.display = 'none');
            }
        } else if (field.type === 'url') {
            value.textContent = field.value;
            value.href = field.value;
        } else if (field.closest('.choices')) {
            // const choices = this.#choices.getChoices(field.id).getValue();

            // value.textContent = wp.i18n.__(choices.length + ' Items','levcharity');

        } else if (['date', 'datetime-local', 'month', 'time', 'week'].includes(field.type)) {
            if (field.value) {
				const formats = {
					date: 'Y-m-d',
					'datetime-local': 'Y-m-d H:i',
					month: 'Y-m',
					time: 'H:i',
					week: `Y-W`
				}

				const val = Helper.date(formats[field.type], Helper.strtotime(field.value))

                value.textContent = val || '';
            } else {
                value.textContent = wp.i18n.__('Unlimited', 'levcharity');
            }
        } else {
            if (field.value === '' && field.dataset?.empty) {
                value.textContent = field.dataset?.empty || '';
            } else if (value.dataset.name === 'campaign_goal' || value.dataset.name === 'campaign_goal_other_amount'  || value.dataset.name === 'team_campaign_goal_other_amount' || value.dataset.name === 'unlimited_goal') {

                let currency = this._MultiStepForms.formWrapper.querySelector('[name=base_currency]') || this._MultiStepForms.formWrapper.querySelector('[name=campaign_goal_other_amount]') ;
                let currency_symbol = currency?.dataset?.currencySymbol || currency?.options[currency?.selectedIndex]?.dataset.symbol || field?.dataset?.currencySymbol;
				if (field.value !== 'other' && field.name === 'campaign_goal') {

                    value.textContent = field.options[field.selectedIndex]?.value ? field.options[field.selectedIndex].textContent : (value.dataset?.empty || '');
                } else {

					const goal = this._MultiStepForms.formWrapper.querySelector('[name="campaign_goal"]')?.value === 'unlimited';
					const isUnlimited = this._MultiStepForms.formWrapper.querySelector('[name="unlimited_goal"]')?.checked || false;

					if (field.name === 'campaign_goal_other_amount' && (goal || isUnlimited)){
						value.textContent = wp.i18n.__('Unlimited Goal', 'levcharity');
					} else {
						let other_amount = this._MultiStepForms.formWrapper.querySelector('[name=campaign_goal_other_amount]')?.value || '';

						if (!other_amount) {
							other_amount = this._MultiStepForms.formWrapper.querySelector('[name=team_campaign_goal_other_amount]')?.value || ''
						}

						value.textContent = other_amount ? currency_symbol +  new Intl.NumberFormat().format(other_amount) : '';
					}
                }
            } else {
                value.textContent = field.value;
            }
        }
    }

    #setFieldValue(field, changedField) {
		if (!field || !changedField || changedField.name === 'action') return;

        if (field.name === 'search_terms') return;

        if (changedField.type === 'file') {
            field.files = changedField.files;
        } else if (changedField.type === 'checkbox') {
            field.checked = changedField.checked;
            field.value = changedField.value;
        } else if(changedField.type === 'radio') {
			if (field.value === changedField.value) {
				field.checked = changedField.checked;
			}
		} else if (field.closest('.choices')) {
            // const choices = this.#choices.getChoices(changedField.id).getValue();
            //
            // if (choices.length) {
            //     this.#choices.getChoices(field.id).setChoiceByValue(choices.map(option => option.value));
            // }
            //
            // if(changedField?.dataset?.options){
            //     field.dataset.options = changedField.dataset.options;
            //     this.#choices.updateContents(field.id);
            // }

        } else {
            field.value = changedField.value;
        }

        if (field.matches('.campaign-goal')) {
            const otherWrapper = field.closest('form')?.querySelector('.campaign-goal-other-wrapper');

            if (field.value === 'other') {
				otherWrapper.style.display = '';
            } else {
				otherWrapper.style.display = 'none';
            }
        }

		this._MultiStepForms.Hook.doAction('changeFieldValue', field, changedField)
    }

	#initTextareas() {
		const fields = this._MultiStepForms.formWrapper.querySelectorAll('input,textarea');

		for (const field of [...fields]) {
			if(field.matches('textarea')) {
				const styles = window.getComputedStyle(field);

				const paddingTop = parseFloat(styles.paddingTop);
				const paddingBottom = parseFloat(styles.paddingBottom);
				const borderTop = parseFloat(styles.borderTopWidth);
				const borderBottom = parseFloat(styles.borderBottomWidth);
				const lineHeight = parseFloat(styles.lineHeight);

				const rows = parseFloat(field.getAttribute('rows') || (field.matches('input') ? 1 : 2));

				const minHeight = rows * lineHeight + paddingTop + paddingBottom + borderTop + borderBottom;
				const maxHeight = minHeight * 3;

				field.style.minHeight = minHeight + 'px';
				field.style.maxHeight = maxHeight + 'px';
			}

			if (!field.getAttribute('maxlength')) continue;

			let remaining = field.parentElement.querySelector('.remaining');

			field.levit_maxlength = field.getAttribute('maxlength');

			if (!remaining) {
				remaining = document.createElement('span');
				remaining.classList.add('remaining');
				if (field.nextElementSibling) {
					field?.nextElementSibling?.parentNode?.insertBefore(remaining, field.nextElementSibling);
				} else {
					field.parentElement.append(remaining);
				}
			}

			if (!remaining.textContent) {
				remaining.textContent = field.value.length + ' / ' + field.levit_maxlength;
			}


		}


		this._MultiStepForms.formWrapper.addEventListener('input', (event) => {

			if ((event.target.matches('textarea,input'))) {
				const field = event.target;

				if (!field?.levit_maxlength) return;

				if (field.value.length > field.levit_maxlength) {
					field.value = field.value.slice(0, -1);
					return false;
				}

				let remaining = field.parentElement.querySelector('.remaining');

				if (!remaining) {
					remaining = document.createElement('span');
					remaining.classList.add('remaining');
					if (field.nextElementSibling) {
						field.nextElementSibling.insertBefore(remaining);
					} else {
						field.parentElement.append(remaining);
					}
				}

				remaining.textContent = field.value.length + '/' + field.levit_maxlength;
			}
		});
	}

	#initPaging() {
		this._MultiStepForms.formSteps
			.forEach((step, index, list) => {
				if (list.length - 1 === index) {
					return;
				}

				const paging = step.querySelector('.paging')
				if (paging) {
					paging.textContent = `${index}/${list.length - 2}`;
				}
			})
	}
}
